import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'data-connection',
  template: ` <router-outlet></router-outlet> `,
  styles: [],
})
export class DataConnectionComponent {
  title: string = 'Data Connection';
  name: string  = '';
  constructor(public route: ActivatedRoute) {}
}
